import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { acBilet } from '../actions/acBilet';

class SistemUnique extends React.Component {

    // constructor() {
    //     super();
    //     this.state = { nrTabs: 2 };
    // }
    changeChecked(val, e) {
        if (val.valid === true) {
            var values = {
                position: val.position,
                checked: val.checked,
                value: parseInt(e.target.value, 10),
                numereArr: val.numereArr,
                type: 'unique'
            }
            this.props.acBilet(['biletChecked', values])
        }
    }
    fact(n) {
        var f = 1;
        for (var i = 2; i <= n; ++i)
            f *= i;
        return f;
    }
    comb(n, k) {
        var aux = 1;
        for (var i = k + 1; i <= n; ++i)
            aux *= i;
        return aux / this.fact(n - k);
    }
    nrPosibilitati(i2, nrLength) {
        var comb = this.comb(nrLength, i2);
        if (nrLength === i2) {
            return "" + comb + " " + this.props.multiLang.pariu.txt + ""
        } else {
            return "" + comb + " " + this.props.multiLang.pariuri.txt + ""
        }
    }
    sisteme() {
        return (
            <div className="sisteme">
                <div className="sisteme-tile"></div>
                <select
                    onChange={this.changeChecked.bind(this, this.props.biletVal)}
                    value={this.props.biletVal.checked[0]}
                >
                    {
                        this.props.biletVal.numereArr.map((val, i) => {
                            if (i < this.props.biletVal.odds.length) {
                                return (
                                    <option key={i} value={i + 1}>{i + 1}/{this.props.biletVal.numereArr.length} - {this.nrPosibilitati(i + 1, this.props.biletVal.numereArr.length)}</option>
                                )
                            } else {
                                return ''
                            }
                        })
                    }
                </select>
            </div>
        )
    }
    render() {
        // console.log('Sisteme', this.props);
        return (
            <div>
                {this.sisteme()}
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        clientProp: state.clientProp,
        multiLang: state.multiLang
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SistemUnique);
